export default "__VITE_ASSET__MP3dm51T__"